import { render, staticRenderFns } from "./NormAdd.form.vue?vue&type=template&id=70552a4f&"
import script from "./NormAdd.form.vue?vue&type=script&lang=js&"
export * from "./NormAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports